import { useFormContext } from "react-hook-form";

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

import { type FormControlProps } from "./types";

export const RadioGroupFormControl = ({ field, name }: FormControlProps) => {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={(context) => (
        <FormItem className="space-y-3">
          <FormLabel>{field.title}</FormLabel>
          <FormControl>
            <RadioGroup
              className="md:flex-col gap-4"
              onValueChange={context.field.onChange}
              defaultValue={context.field.value}
              value={context.field.value}
            >
              {field.options.map((option) => (
                <FormItem
                  key={option.key}
                  className="flex items-center space-x-3 space-y-0"
                >
                  <FormLabel className="inline-flex items-center gap-x-2 cursor-pointer">
                    <FormControl>
                      <RadioGroupItem value={option.key} />
                    </FormControl>
                    {option.value}
                  </FormLabel>
                </FormItem>
              ))}
            </RadioGroup>
          </FormControl>
          {field.description && (
            <FormDescription>{field.description}</FormDescription>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
